import {type TabCommunicationInterface, type TabCommunicationEvent} from './TabCommunication.ts'

export class TabCommunicationBroadcastChannel implements TabCommunicationInterface {
    private readonly broadcastChannel: BroadcastChannel
    private readonly eventCallbacks: Map<TabCommunicationEvent, () => void>

    private readonly CHANNEL_NAME = 'colonist'

    constructor() {
        this.broadcastChannel = new BroadcastChannel(this.CHANNEL_NAME)
        this.eventCallbacks = new Map()

        this.broadcastChannel.addEventListener('message', (message: MessageEvent<TabCommunicationEvent>) => {
            const callback = this.eventCallbacks.get(message.data)
            callback?.()
        })
    }

    static isAvailable(): boolean {
        return typeof BroadcastChannel === 'function'
    }

    sendEvent(event: TabCommunicationEvent): void {
        this.broadcastChannel.postMessage(event)
    }

    onEvent(event: TabCommunicationEvent, callback: () => void): void {
        this.eventCallbacks.set(event, callback)
    }
}
